import { render, staticRenderFns } from "./leafPolygon.vue?vue&type=template&id=ef0f7c46&scoped=true&"
import script from "./leafPolygon.vue?vue&type=script&lang=js&"
export * from "./leafPolygon.vue?vue&type=script&lang=js&"
import style0 from "./leafPolygon.vue?vue&type=style&index=0&id=ef0f7c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0f7c46",
  null
  
)

component.options.__file = "leafPolygon.vue"
export default component.exports